import { axiosInstance } from ".."

const customOrderStatus = async (data) =>{

    return new Promise(async (resolve,reject)=>{
        axiosInstance.post(`/internal/CustomOrder/updateOrderStatus`,data).then((res) => { 
            if(res.status === 200){
                return resolve(res)
            }
            return resolve(res)
        }).catch((err) => {
            return reject(err)
        })
    })
}

export default customOrderStatus;